import { render, staticRenderFns } from "./BaseTabGroup.vue?vue&type=template&id=052a7530&scoped=true&"
import script from "./BaseTabGroup.vue?vue&type=script&lang=js&"
export * from "./BaseTabGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabGroup.vue?vue&type=style&index=0&id=052a7530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a7530",
  null
  
)

export default component.exports